import React, { FC } from 'react'

export const DisplayCampaigns: FC = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m21.875 29.535-2.586 2.586 2.586 2.586"
      stroke="#026AE1"
      strokeWidth="1.293"
      strokeMiterlimit="10"
    />
    <path
      d="M33.664 14.751c1.152 3.917.471 8.573-2.4 12.203a13.592 13.592 0 0 1-10.68 5.167h-1.268M29.453 12.081l3.533.947.946-3.533M17.349 31.766c-5.953-1.441-10.345-6.822-10.345-13.222.001-2.3.586-4.633 1.82-6.77l.647-1.12"
      stroke="#026AE1"
      strokeWidth="1.293"
      strokeMiterlimit="10"
    />
    <path
      d="M10.75 9.15c2.367-2.485 5.937-4.189 9.834-4.18a13.593 13.593 0 0 1 11.757 6.804l.646 1.12M10.418 14.32l-.946-3.532-3.533.946M30.953 18.545s-4.631 5.172-10.344 5.172c-5.713 0-10.343-5.172-10.343-5.172s4.63-5.172 10.343-5.172 10.343 5.172 10.343 5.172Z"
      stroke="#026AE1"
      strokeWidth="1.293"
      strokeMiterlimit="10"
    />
    <path
      d="M23.84 18.545a3.233 3.233 0 1 1-6.466 0 3.233 3.233 0 0 1 6.466 0Z"
      stroke="#026AE1"
      strokeWidth="1.293"
      strokeMiterlimit="10"
    />
  </svg>
)
